/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EmailTemplate } from 'types/entities/EmailTemplate'

export interface EmailTemplatesState {
    templatesByModel: Record<string, Record<number, EmailTemplate[]>>
    isLoading: boolean
}

const initialState: EmailTemplatesState = {
    templatesByModel: {},
    isLoading: false,
}

const emailTemplatesSlice = createSlice({
    name: 'emailTemplates',
    initialState,
    reducers: {
        setTemplatesForModel(
            state,
            action: PayloadAction<{ modelName: string; modelId: number; templates: EmailTemplate[] }>
        ) {
            const { modelName, modelId, templates } = action.payload
            if (!state.templatesByModel[modelName]) {
                state.templatesByModel[modelName] = {}
            }
            state.templatesByModel[modelName][modelId] = templates
        },
        pushTemplate(state, action: PayloadAction<EmailTemplate>) {
            const template = action.payload
            const { model_name, model_id } = template

            if (!state.templatesByModel[model_name]) {
                state.templatesByModel[model_name] = {}
            }
            if (!state.templatesByModel[model_name][model_id]) {
                state.templatesByModel[model_name][model_id] = []
            }

            const index = state.templatesByModel[model_name][model_id].findIndex((t) => t.id === template.id)
            if (index === -1) {
                state.templatesByModel[model_name][model_id].push(template)
            } else {
                state.templatesByModel[model_name][model_id][index] = template
            }
        },
        removeTemplate(state, action: PayloadAction<{ modelName: string; modelId: number; templateId: number }>) {
            const { modelName, modelId, templateId } = action.payload
            if (state.templatesByModel[modelName] && state.templatesByModel[modelName][modelId]) {
                state.templatesByModel[modelName][modelId] = state.templatesByModel[modelName][modelId].filter(
                    (t) => t.id !== templateId
                )
            }
        },
        setIsLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload
        },
        resetState: () => initialState,
    },
})

export const { setTemplatesForModel, pushTemplate, removeTemplate, setIsLoading, resetState } = emailTemplatesSlice.actions

export default emailTemplatesSlice.reducer
